import React from 'react';
import PropTypes from 'prop-types';
import DaysOfWeek from '../days-of-week';
import FormField from './form-field';

function DaysOfWeekField(props) {
  const {name, multiselect, values, setFieldValue, handleBlur, ...rest} = props;

  const handleChange = values => {
    const fieldValue = multiselect ? values.map(value => value.value) : values.value;
    setFieldValue(name, fieldValue);
  };

  return (
    <DaysOfWeek
      name={name}
      value={values[name]}
      multiselect={multiselect}
      onChange={handleChange}
      onBlur={handleBlur}
      {...rest}
    />
  );
}

DaysOfWeekField.defaultProps = {
  multiselect: true,
};

DaysOfWeekField.propTypes = {
  name: PropTypes.string,
  multiselect: PropTypes.bool,
  values: PropTypes.object,
  touched: PropTypes.object,
  changed: PropTypes.object,
  errors: PropTypes.object,
  setFieldValue: PropTypes.func,
  handleBlur: PropTypes.func,
};

export default function FormDaysOfWeekField(props) {
  const {controlProps, ...rest} = props;

  return (
    <FormField {...rest}>
      <DaysOfWeekField {...controlProps} />
    </FormField>
  );
}

FormDaysOfWeekField.propTypes = {
  /** Additional props to pass to the FormControl. */
  controlProps: PropTypes.object,
};
